import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { api, formatError } from "../lib/apiClient";
import { passwordPolicyError } from "../lib/passwordPolicy";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { CheckSquare, Loader2 } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) return toast.error("Şifreler eşleşmiyor");
    const policyError = passwordPolicyError(password);
    if (policyError) return toast.error(policyError);
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Şifreniz güncellendi. Giriş yapabilirsiniz.");
      navigate("/giris");
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-8">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-2 mb-8">
          <div className="w-9 h-9 rounded-md bg-primary flex items-center justify-center"><CheckSquare className="w-5 h-5 text-primary-foreground" /></div>
          <span className="font-head font-bold text-xl tracking-tight">OfisGörev</span>
        </div>
        <h2 className="font-head font-bold text-3xl tracking-tight mb-1">Yeni Şifre</h2>
        <p className="text-muted-foreground mb-8">Hesabınız için yeni bir şifre belirleyin.</p>
        {!token ? (
          <p className="text-sm text-destructive">Geçersiz bağlantı. <Link to="/giris" className="text-primary underline">Girişe dön</Link></p>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div className="space-y-2">
              <Label>Yeni Şifre</Label>
              <Input data-testid="new-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••••••" minLength={12} maxLength={128} required />
              <p className="text-xs text-muted-foreground">En az 12 karakter; büyük/küçük harf, rakam ve sembol gruplarından en az üçünü kullanın.</p>
            </div>
            <div className="space-y-2">
              <Label>Yeni Şifre (Tekrar)</Label>
              <Input data-testid="confirm-password-input" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="••••••••••••" minLength={12} maxLength={128} required />
            </div>
            <Button type="submit" disabled={loading} className="w-full h-11 font-medium" data-testid="reset-submit-btn">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Şifreyi Güncelle"}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
